<template>
  <div id="navigationmaster">
    <div class="container admin-wrap">
      <div class="row header mb-2">
        <div class="col-lg-4">
          <h3 class="text-left mb-3">{{ $route.name }}</h3>
        </div>
        <div class="col-lg-8 actionDiv">
          <el-button-group>
            <el-button type="primary" variant="primary" v-on:click="showNewMenuModal()"> New Menu </el-button>
            <el-button type="primary" variant="primary" v-on:click="showSubMenuWithoutMenu()"> Sub Menu without Menu </el-button>
            <el-button type="primary" variant="primary" v-on:click="showAccessMenu()"> Access Menu </el-button>
          </el-button-group>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="MenuListInt.length < 1">
          <strong>No Record</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="MenuListInt.length > 0" class="datatable_group">
          <data-tables :data="MenuListInt" :action-col="MenuListAction">
            <el-table-column v-for="MenuListInfo in MenuList" :prop="MenuListInfo.prop" :label="MenuListInfo.label" :key="MenuListInfo.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Sub Menu" min-width="100px">
              <template slot-scope="scope">
                <el-button v-for="SubMenuAction in SubMenu(scope.row)" :key="SubMenuAction.name" type="primary" @click="SubMenuAction.handler">
                  <span class="el-icon-edit"></span> {{ SubMenuAction.name }}
                </el-button>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
    <b-modal id="newMenuModal" size="lg" title="Create New Menu" ok-only ok-variant="secondary" hide-footer ref="newMenuModalShow">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Menu Name</label>
          <input type="text" class="form-control" v-model="inputNewMenuName" />
        </div>
        <hr class="custom-hr" />
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button v-on:click="saveNavigationMenu()" class="btn btn-primary waves-effect waves-light m-r-10">Save</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="subMenuModal" size="lg" title="Sub Menu" ok-only ok-variant="secondary" hide-footer ref="subMenuModalShow">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <label>Sub Menu Name</label>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <input type="text" class="form-control" v-model="inputNewSubMenuName" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <label>Sub Menu Link</label>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <input type="text" class="form-control" v-model="inputNewSubMenuLink" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button v-on:click="saveNavigationSubMenu()" class="btn btn-primary waves-effect waves-light m-r-10">Save</button>
        </div>
      </div>
      <hr class="custom-hr" />
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <label>Sub Menu List</label>
      </div>
      <div class="empty-list_image" v-if="SubMenuListInt.length < 1">
        <strong>No Record</strong>
        <img src="../assets/notfound.png" />
      </div>
      <div v-if="SubMenuListInt.length > 0" class="datatable_group">
        <data-tables :data="SubMenuListInt" :action-col="SubMenuListAction">
          <el-table-column
            v-for="SubMenuListInfo in SubMenuList"
            :prop="SubMenuListInfo.prop"
            :label="SubMenuListInfo.label"
            :key="SubMenuListInfo.prop"
            sortable="custom"
          >
          </el-table-column>
        </data-tables>
      </div>
    </b-modal>
    <b-modal id="subMenuWithoutMenuModal" size="lg" title="Sub Menu without Menu" ok-only ok-variant="secondary" hide-footer ref="subMenuWithoutMenuModalShow">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <label>Sub Menu Name</label>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <input type="text" class="form-control" v-model="inputNewSubMenuNameWithoutMenu" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <label>Sub Menu Link</label>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <input type="text" class="form-control" v-model="inputNewSubMenuLinkWithoutMenu" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button v-on:click="saveNavigationSubMenuWithoutMenu()" class="btn btn-primary waves-effect waves-light m-r-10">Save</button>
        </div>
      </div>
      <hr class="custom-hr" />
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <label>Sub Menu without Menu List</label>
      </div>
      <div class="empty-list_image" v-if="SubMenuWithoutMenuListInt.length < 1">
        <strong>No Record</strong>
        <img src="../assets/notfound.png" />
      </div>
      <div v-if="SubMenuWithoutMenuListInt.length > 0" class="datatable_group">
        <data-tables :data="SubMenuWithoutMenuListInt" :action-col="SubMenuWithoutMenuListAction">
          <el-table-column
            v-for="SubMenuWithoutMenuListInfo in SubMenuWithoutMenuList"
            :prop="SubMenuWithoutMenuListInfo.prop"
            :label="SubMenuWithoutMenuListInfo.label"
            :key="SubMenuWithoutMenuListInfo.prop"
            sortable="custom"
          >
          </el-table-column>
        </data-tables>
      </div>
    </b-modal>
    <b-modal id="accessMenuModal" size="lg" title="Access Menu" ok-only ok-variant="secondary" hide-footer ref="accessMenuModalShow">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <label>Select Group</label>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <select v-model="ddlUserGroup" class="form-control pro-edt-select form-control-primary" @change="onDdlUserGroup()">
            <option v-for="item in userGroupList" v-bind:value="item.GRPid">
              {{ item.GRPname }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="ddlUserGroup !== ''">
        <hr class="custom-hr" />
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>{{ currentGroupAccessName }} - {{ currentGroupAccessID }}</label>
        </div>
        <div class="row">
          <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
            <select v-model="ddlNewSubMenu" class="form-control pro-edt-select form-control-primary">
              <option v-for="item in newSubMenuList" v-bind:value="item.NavSmID">
                [{{ item.NavSmName }}] - [{{ item.NavSmLink }}] <span v-if="item.Type === 'With Menu'">({{ item.MenuName }})</span>
              </option>
            </select>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
            <el-button type="primary" variant="primary" v-on:click="saveMenuAccess()"> Add </el-button>
          </div>
        </div>
        <div class="empty-list_image" v-if="groupAccessListInt.length < 1">
          <strong>No Record</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="groupAccessListInt.length > 0" class="datatable_group">
          <data-tables :data="groupAccessListInt" :action-col="groupAccessListAction">
            <el-table-column
              v-for="groupAccessListInfo in groupAccessList"
              :prop="groupAccessListInfo.prop"
              :label="groupAccessListInfo.label"
              :key="groupAccessListInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { MEDICINE_MENUS } from '../constants/medicine-menu'
import DataSource from '../data/datasource'
import { showMedicineMenu } from '../helper/util_custom'

export default {
  name: 'NavigationMaster',
  data() {
    return {
      inputNewMenuName: '',
      currentMenuID: '',
      inputNewSubMenuName: '',
      inputNewSubMenuLink: '',
      inputNewSubMenuNameWithoutMenu: '',
      inputNewSubMenuLinkWithoutMenu: '',
      userGroupList: [],
      ddlUserGroup: '',
      currentGroupAccessName: '',
      currentGroupAccessID: '',
      ddlNewSubMenu: '',
      newSubMenuList: [],

      MenuListInt: [],
      MenuList: [
        {
          prop: 'NavMnName',
          label: 'Menu Name',
        },
      ],
      MenuListAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },
            handler: row => {
              this.deleteNavigationMenu(row.NavMnID)
            },
            label: 'Delete',
          },
        ],
      },

      SubMenuListInt: [],
      SubMenuList: [
        {
          prop: 'NavSmName',
          label: 'Sub Menu Name',
        },
        {
          prop: 'NavSmLink',
          label: 'Link',
        },
      ],
      SubMenuListAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },
            handler: row => {
              this.deleteNavigationSubMenu(row.NavSmID, 'SubMenu')
            },
            label: 'Delete',
          },
        ],
      },

      SubMenuWithoutMenuListInt: [],
      SubMenuWithoutMenuList: [
        {
          prop: 'NavSmName',
          label: 'Sub Menu Name',
        },
        {
          prop: 'NavSmLink',
          label: 'Link',
        },
      ],
      SubMenuWithoutMenuListAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },
            handler: row => {
              this.deleteNavigationSubMenu(row.NavSmID, 'SubMenuWithoutMenu')
            },
            label: 'Delete',
          },
        ],
      },

      groupAccessListInt: [],
      groupAccessList: [
        {
          prop: 'NavMnName',
          label: 'Menu Name',
        },
        {
          prop: 'NavSmName',
          label: 'Sub Menu Name',
        },
        {
          prop: 'NavSmLink',
          label: 'Sub Menu Link',
        },
        {
          prop: 'type',
          label: 'Type',
        },
      ],
      groupAccessListAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },
            handler: row => {
              this.deleteMenuAccess(row.NavGaID)
            },
            label: 'Delete',
          },
        ],
      },
    }
  },
  async created() {
    this.getNavigationMenuMaster()
    this.getUserGroup()
  },
  methods: {
    async getUserGroup() {
      try {
        const response = await DataSource.shared.getUserGroup()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getUserGroup error')
          } else {
            this.userGroupList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getNavigationMenuMaster() {
      try {
        const response = await DataSource.shared.getNavigationMenuMaster()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getNavigationMenuMaster error')
          } else if (response.code === '2') {
            this.MenuListInt = []
          } else {
            this.MenuListInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async saveNavigationMenu() {
      try {
        if (this.inputNewMenuName === '') {
          this.$notify({
            title: 'Required',
            message: 'All fields require...',
          })
        } else {
          const response = await DataSource.shared.saveNavigationMenu(this.inputNewMenuName)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('saveNavigationMenu error')
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Menu Name Duplicated...',
              })
            } else {
              this.inputNewMenuName = ''
              this.$refs.newMenuModalShow.hide()
              this.getNavigationMenuMaster()

              this.$notify({
                title: 'Success',
                message: 'Successfully saved',
                type: 'success',
              })
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async deleteNavigationMenu(menuID, mode) {
      try {
        const response = await DataSource.shared.updateNavigationMenu(menuID, 'Delete')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('updateNavigationMenu error')
          } else {
            if (mode === 'SubMenu') {
              this.getNavigationMenuMaster()
            } else if (mode === 'SubMenuWithoutMenu') {
              this.getNavigationSubMenuWithoutMenu()
            }

            this.$notify({
              title: 'Success',
              message: 'Menu Successfully Deleted',
              type: 'success',
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getNavigationSubMenuByMenuID(menuID) {
      try {
        const response = await DataSource.shared.getNavigationSubMenuByMenuID(menuID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getNavigationSubMenuByMenuID error')
          } else if (response.code === '2') {
            this.SubMenuListInt = []
          } else {
            const submenus = !showMedicineMenu() ? response.Table.filter(m => !MEDICINE_MENUS.includes(m.NavSmName)) : response.Table

            this.SubMenuListInt = submenus
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async saveNavigationSubMenu() {
      try {
        if (this.inputNewSubMenuName === '' || this.inputNewSubMenuLink === '' || this.currentMenuID === '') {
          this.$notify({
            title: 'Required',
            message: 'All fields require...',
          })
        } else {
          const response = await DataSource.shared.saveNavigationSubMenu(this.inputNewSubMenuName, this.inputNewSubMenuLink, this.currentMenuID)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('saveNavigationSubMenu error')
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Sub Menu Link Duplicated...',
              })
            } else if (response.code === '3') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Sub Menu Name Duplicated...',
              })
            } else {
              this.inputNewSubMenuName = ''
              this.inputNewSubMenuLink = ''
              this.getNavigationSubMenuByMenuID(this.currentMenuID)

              this.$notify({
                title: 'Success',
                message: 'Successfully saved',
                type: 'success',
              })
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async deleteNavigationSubMenu(subMenuID) {
      try {
        const response = await DataSource.shared.updateNavigationSubMenu(subMenuID, 'Delete')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('updateNavigationSubMenu error')
          } else {
            this.inputNewSubMenuName = ''
            this.inputNewSubMenuLink = ''
            this.getNavigationSubMenuByMenuID(this.currentMenuID)

            this.$notify({
              title: 'Success',
              message: 'Sub Menu Successfully Deleted',
              type: 'success',
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getNavigationSubMenuWithoutMenu() {
      try {
        const response = await DataSource.shared.getNavigationSubMenuWithoutMenu()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getNavigationMenuMaster error')
          } else if (response.code === '2') {
            this.SubMenuWithoutMenuListInt = []
          } else {
            this.SubMenuWithoutMenuListInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async saveNavigationSubMenuWithoutMenu() {
      try {
        if (this.inputNewSubMenuNameWithoutMenu === '' || this.inputNewSubMenuLinkWithoutMenu === '') {
          this.$notify({
            title: 'Required',
            message: 'All fields require...',
          })
        } else {
          const response = await DataSource.shared.saveNavigationSubMenu(this.inputNewSubMenuNameWithoutMenu, this.inputNewSubMenuLinkWithoutMenu, 'No')
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('saveNavigationSubMenu error')
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Sub Menu Link Duplicated...',
              })
            } else if (response.code === '3') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Sub Menu Name Duplicated...',
              })
            } else {
              this.getNavigationSubMenuWithoutMenu()
              this.inputNewSubMenuNameWithoutMenu = ''
              this.inputNewSubMenuLinkWithoutMenu = ''

              this.$notify({
                title: 'Success',
                message: 'Successfully saved',
                type: 'success',
              })
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getNavigationGroupAccessByGroupID(groupID) {
      try {
        const response = await DataSource.shared.getNavigationGroupAccessByGroupID(groupID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getNavigationMenuMaster error')
          } else if (response.code === '2') {
            this.groupAccessListInt = []
          } else {
            this.groupAccessListInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getUnassignedSubMenuToGroupAccessByGroupID(groupID) {
      try {
        const response = await DataSource.shared.getUnassignedSubMenuToGroupAccessByGroupID(groupID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getUnassignedSubMenuToGroupAccessByGroupID error')
          } else if (response.code === '2') {
            this.newSubMenuList = []
          } else {
            this.newSubMenuList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async saveMenuAccess() {
      try {
        if (this.ddlNewSubMenu === '' || this.currentGroupAccessID === '') {
          this.$notify({
            title: 'Required',
            message: 'Please select Sub Menu to add...',
          })
        } else {
          const response = await DataSource.shared.saveNavigationGroupAccess(this.ddlNewSubMenu, this.currentGroupAccessID)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('saveNavigationGroupAccess error')
            } else {
              this.onDdlUserGroup()

              this.$notify({
                title: 'Success',
                message: 'Successfully saved',
                type: 'success',
              })
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async deleteMenuAccess(groupAccessID) {
      try {
        const response = await DataSource.shared.updateNavigationGroupAccess(groupAccessID, 'Delete')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('updateNavigationGroupAccess error')
          } else {
            this.onDdlUserGroup()

            this.$notify({
              title: 'Success',
              message: 'Successfully deleted',
              type: 'success',
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    showNewMenuModal() {
      this.inputNewMenuName = ''
      this.$refs.newMenuModalShow.show()
    },
    SubMenu(row) {
      return [
        {
          name: 'Sub Menu',
          handler: _ => {
            this.inputNewSubMenuName = ''
            this.inputNewSubMenuLink = ''
            this.currentMenuID = row.NavMnID
            this.getNavigationSubMenuByMenuID(row.NavMnID)
            this.$refs.subMenuModalShow.show()
          },
        },
      ]
    },
    showSubMenuWithoutMenu() {
      this.getNavigationSubMenuWithoutMenu()

      this.inputNewSubMenuNameWithoutMenu = ''
      this.inputNewSubMenuLinkWithoutMenu = ''
      this.$refs.subMenuWithoutMenuModalShow.show()
    },
    showAccessMenu() {
      this.ddlUserGroup = ''
      this.ddlNewSubMenu = ''
      this.newSubMenuList = []
      this.$refs.accessMenuModalShow.show()
    },
    onDdlUserGroup() {
      this.ddlNewSubMenu = ''
      this.newSubMenuList = []

      this.getNavigationGroupAccessByGroupID(this.ddlUserGroup)
      this.getUnassignedSubMenuToGroupAccessByGroupID(this.ddlUserGroup)

      let getCurrentGroupAccessName = this.userGroupList.filter(m => m.GRPid === this.ddlUserGroup)
      this.currentGroupAccessName = getCurrentGroupAccessName[0].GRPname
      this.currentGroupAccessID = getCurrentGroupAccessName[0].GRPid
    },
  },
}
</script>

<style scoped>
.actionDiv {
  text-align: right;
}
</style>
